/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateEmailSignatureDto
 */
export interface UpdateEmailSignatureDto {
    /**
     * The label in the list, e.g. \"Erik – Support (EN)\". Not printed in the signature.
     * @type {string}
     * @memberof UpdateEmailSignatureDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailSignatureDto
     */
    'fullName': string;
    /**
     * Empty = no job title line.
     * @type {string}
     * @memberof UpdateEmailSignatureDto
     */
    'jobTitle': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailSignatureDto
     */
    'email': string;
    /**
     * As the operator writes it; dialled in E.164. A national number is read as German. Empty = no row.
     * @type {string}
     * @memberof UpdateEmailSignatureDto
     */
    'phone': string;
    /**
     * Same rules as phone. Empty = no row.
     * @type {string}
     * @memberof UpdateEmailSignatureDto
     */
    'mobile': string;
    /**
     * Absolute HTTPS URL of a square portrait; replaces the logo. Empty = the logo (or none).
     * @type {string}
     * @memberof UpdateEmailSignatureDto
     */
    'photoUrl': string;
    /**
     * The signature\'s language (labels, legal block) — not the operator\'s UI language.
     * @type {string}
     * @memberof UpdateEmailSignatureDto
     */
    'locale': UpdateEmailSignatureDtoLocaleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmailSignatureDto
     */
    'showLogo': boolean;
    /**
     * Legal name, address, representatives and USt-IdNr. from COMPANY_IDENTITY.
     * @type {boolean}
     * @memberof UpdateEmailSignatureDto
     */
    'showLegal': boolean;
    /**
     * The `updatedAt` of the version the operator edited. A different current value answers 409.
     * @type {string}
     * @memberof UpdateEmailSignatureDto
     */
    'expectedUpdatedAt': string;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateEmailSignatureDtoLocaleEnum {
    De = 'de',
    En = 'en'
}


